import { AfterContentChecked, ChangeDetectorRef, Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, FormGroupDirective, NgForm, Validators, AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { LoginResult } from '../../../../models/loginResult';
import { SnackbarService } from '../../../../services/snackbar.service';
import { StateService } from '../../../../services/state.service';
import { TranslocoService } from '@jsverse/transloco';

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const invalidCtrl = !!(control && control.invalid && control.parent?.dirty);
    const invalidParent = !!(
      control &&
      control.parent &&
      control.parent.invalid &&
      control.parent.dirty
    );

    return invalidCtrl || invalidParent;
  }
}

export function passwordRequirementsValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value) {
      return null;
    }
    const hasLower = /[a-z]/.test(value);
    const hasUpper = /[A-Z]/.test(value);
    const hasNumber = /[0-9]/.test(value);
    const hasSymbol = /[\W_]/.test(value);
    const hasMinLength = value.length >= 8;

    const valid = hasLower && hasUpper && hasNumber && hasSymbol && hasMinLength;
    return valid ? null : { passwordRequirements: true };
  };
}

export function passwordMatchValidator(group: AbstractControl): ValidationErrors | null {
  const pass = group.get('password')?.value;
  const confirmPass = group.get('confirmedPassword')?.value;
  if (!pass || !confirmPass) {
    return null;
  }
  return pass === confirmPass ? null : { notSame: true };
}

@Component({
  selector: 'app-activate-user',
  templateUrl: './activate-user.component.html',
  styleUrls: ['./activate-user.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ActivateUserComponent implements OnInit, AfterContentChecked {
  matcher = new MyErrorStateMatcher();
  passwordMatchError = false;
  showDetails: boolean;
  hidePassword = true;
  hideConfirmPassword = true;
  public confirmpassword: string;
  public code: string;
  activateUserForm: UntypedFormGroup;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private snackbar: SnackbarService,
    private stateservice: StateService,
    private cdref: ChangeDetectorRef,
    private translate: TranslocoService
  ) { }

  ngOnInit(): void {
    this.activateUserForm = new UntypedFormGroup(
      {
        code: new UntypedFormControl(''),
        password: new UntypedFormControl('', [Validators.required, passwordRequirementsValidator()]),
        confirmedPassword: new UntypedFormControl('', [Validators.required])
      },
      { validators: passwordMatchValidator }
    );

    this.activatedRoute.queryParams.subscribe((params: Params) => {
      this.code = params.code;
      this.router.navigate(['/activateuser'], { queryParams: { code: this.code } });
    });
  }

  public activateUser() {
    this.stateservice
      .activateUser(this.code, this.activateUserForm.controls['confirmedPassword'].value)
      .subscribe(
        (result: LoginResult) => {
          if (result.status === 21) {
            this.snackbar.openSnackBar(result.status.toString(), '');
          } else if (result.status === 27) {
            const message = this.translate.translate('KEY_STATUS_MESSAGE.0') || 'Something went wrong';
            this.snackbar.openSnackBar(message, 'OK');
          } else if (result.status === 28) {
            this.snackbar.openSnackBar(result.status.toString(), '');
          } else {
            this.snackbar.openSnackBar('Välkommen', '');
            this.router.navigate(['/']);
          }
        },
        (error: LoginResult) => {
          console.error(error);
        }
      );
  }

  ngAfterContentChecked() {
    this.cdref.detectChanges();
  }

  onStrengthChanged(strength: number) {
    console.log('password strength = ', strength);
  }
}
